/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Hold_ReleasedInputs */

const en_inventory_hold_released = /** @type {(inputs: Inventory_Hold_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory hold released`)
};

const es_inventory_hold_released = /** @type {(inputs: Inventory_Hold_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartado de inventario liberado`)
};

/**
* | output |
* | --- |
* | "Inventory hold released" |
*
* @param {Inventory_Hold_ReleasedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_hold_released = /** @type {((inputs?: Inventory_Hold_ReleasedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Hold_ReleasedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_hold_released(inputs)
	return es_inventory_hold_released(inputs)
});